import { useApiFetcherSWR } from 'hooks/SwrCustom';

export const API_ENDPOINT = {
    GET_AFAS_GEBRUIKERS: (communityId) => ({
        url: `bestuur/afas-gebruikers?iCommunityId=${communityId}`,
        method: 'get',
    }),
    ADD_AFAS_GEBRUIKER: {
        url: 'bestuur/afas-gebruikers',
        method: 'post',
    },
    REMOVE_AFAS_GEBRUIKER: {
        url: 'bestuur/afas-gebruikers',
        method: 'delete',
    },
};

export const useAfasGebruikers = (communityId) =>
    useApiFetcherSWR(
        communityId ? API_ENDPOINT.GET_AFAS_GEBRUIKERS(communityId) : null,
    );

export const useAddAfasGebruiker = () =>
    useApiFetcherSWR(API_ENDPOINT.ADD_AFAS_GEBRUIKER);

export const useRemoveAfasGebruiker = () =>
    useApiFetcherSWR(API_ENDPOINT.REMOVE_AFAS_GEBRUIKER);
